(ns frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.esg
  (:require
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.report.esg.gresb :as esg-gresb]))

(defn esg-targets-incidents-page
  [report-data]
  (let [{:keys [esg-targets-and-strategy-text ungc-esg-incidents-text]} (:esg report-data)]
    (page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Sustainability" :toc-item true})
     (column/column
      (card/card
       "Sustainability targets and strategy"
       (text-content/rich-content (:rich-content esg-targets-and-strategy-text)))))))

(defn esg-kpis-page
  [report-data]
  (let [gresb (get-in report-data [:esg :gresb])
        key-performance-indicators (-> report-data
                                       :esg
                                       :key-performance-indicators)]
    (page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Sustainability"})
     (column/column
      (card/card
       "Key Performance Indicators"
       {:layout :noBorders
        :table  {:widths [300 "auto"]
                 :body
                 [[{:stack [(table/dynamic-table
                             {:parsed-data (:figures key-performance-indicators)
                              :even-color  (theme/color [:pdf :table :even-color])
                              :odd-color   (theme/color [:pdf :table :odd-color])})
                            (text-content/optional-footer key-performance-indicators)]}
                   (if (and gresb
                            (not= gresb "none"))
                     (card/card
                      nil
                      {:image  gresb
                       :margin [20 20 20 20]
                       :relativePosition {:y -30}
                       :width  150})
                     {:stack []})]]}})))))

(defn esg-renewables-scopes-incidents-page
  [report-data]
  (page/page
   (page/page-title {:fund-name (:fund-name report-data) :page-title "Sustainability"})
   (column/column
    (column/columns
     (card/card "Share of fossil-free energy"
                {:svg   (chart-view/chart-svg "highcharts"
                                              (-> report-data
                                                  :esg
                                                  :renewables
                                                  :figures))
                 :width 350}
                (text-content/optional-footer (-> report-data
                                                  :esg
                                                  :renewables)))
     (card/card "Greenhouse gas emissions (tCO2e)"
                {:svg   (chart-view/chart-svg "highcharts"
                                              (-> report-data
                                                  :esg
                                                  :scopes
                                                  :figures))
                 :width 350}
                (text-content/optional-footer (-> report-data
                                                  :esg
                                                  :scopes))))
    (card/card
     "UNGC Sustainability incidents"
     (text-content/rich-content (get-in report-data
                                        [:esg :ungc-esg-incidents-text :rich-content]))))))

(defn esg-pages
  [report-data]
  [(esg-targets-incidents-page report-data)
   (esg-kpis-page report-data)
   (esg-renewables-scopes-incidents-page report-data)])
